// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAVEh0IBtLKCN6CVd_U1bMv4OlqQp5_w4U",
    authDomain: "isn-fleet-management-system.firebaseapp.com",
    databaseURL: "https://isn-fleet-management-system.firebaseio.com",
    projectId: "isn-fleet-management-system",
    storageBucket: "isn-fleet-management-system.appspot.com",
    messagingSenderId: "251841025483",
    appId: "1:251841025483:web:46367a0012543e7578124e",
    measurementId: "G-QVHP16YJCE"
  }
};
